<template>
    <div>
        <!-- HEAD -->

        <div class="head row p-0 g-0" data-aos="fade-in" data-aos-delay="100" data-aos-duration="3000" >
            <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 col-xxl-7 p-0">
                <img :src="`${publicPath}img/01innovacion.jpg`" class="img-responsive">
            </div>
            <div class="headRight p-3 pt-xl-2 px-xl-5 px-xxl-0 ps-xxl-5">
                <div class="row justify-content-end">
                    <div class="col-2 m-0 me-3  mb-4 mt-3 p-0">
                        <img :src="`${publicPath}img/01innovacion-headIcon.gif`" class="img-responsive">
                    </div>
                </div>
                <h2>{{ $t('futuro.innovacion') }}</h2>
                <p class="text-end pt-2 pt-xl-3">{{ $t('roca-group-entiende-la-innovacion-como') }}</p>
            </div>
        </div>

        <!-- end HEAD -->

        <div class="contingut bg-white row g-0">
            <div class="col-8 pt-3 pt-lg-5 pb-5 pb-lg-0 px-3 px-lg-0 m-auto">
                <h2 data-aos="fade" data-aos-duration="1500">{{ $t('roca-group-ventures-fondo-de-inversion-en-start-ups') }}</h2>
            </div>
        </div>

        <div class="contingut bg-white row g-0 mb-0 pb-5">
            <div class="col-12 py-5 fonsGris position-relative">
                <div class="blocCollapseR">
                    <a class="btnCollapseIn btnFosc" data-bs-toggle="collapse" href="#collapse01" role="button" aria-expanded="false" aria-controls="collapse01"><i class="fa-solid fa-plus"></i></a>
                    <div class="collapse collapseR" id="collapse01">
                        <div class="card card-body txtCollapse">
                            <div class="row align-items-center">
                                <div class="col-12">
                                    <div class="zonaCollapse">
                                        <a class="btnCollapseIn btnTancar" data-bs-toggle="collapse" href="#collapse01" role="button" aria-expanded="false" aria-controls="collapse01"><i class="fa-solid fa-xmark"></i></a>
                                    </div>
                                </div>
                                <div class="col-12 p-0 p-lg-5">
                                    <div class="col-12 col-lg-9 m-auto p-5">
                                    <p class="text-white"><br>{{ $t('la-apuesta-por') }}<br></p>
                                    <p class="text-white"><br>{{ $t('este-modelo-de-emprendimiento') }}<br><br></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <h4 class="pb-3 mb-3" v-html="$t('las-cuatro-areas-principales')"></h4>
                <div class="row justify-content-center ods">
                    <div class="col-11 col-xxl-10">
                        <div class="row justify-content-center ods">
                            <div class="col-12 col-lg-3 px-3 px-xxl-5" data-aos="fade-right" data-aos-duration="1000">
                                <img :src="`${publicPath}img/01innovacionIcp01.png`" class="img-responsive my-3">
                                <p>
                                <strong class="text-blau2">{{ $t('wellness-y-banos-inteligentes') }}</strong><br>
                                {{ $t('aplicacion-de-la-inteligencia-artificial') }}
                                </p>
                            </div>
                            <div class="col-12 col-lg-3 px-3 px-xxl-5" data-aos="fade-right" data-aos-delay="200" data-aos-duration="800">
                                <img :src="`${publicPath}img/01innovacionIcp02.png`" class="img-responsive my-3">
                                <p>
                                <strong class="text-blau2">{{ $t('nuevos-negocios-y-materiales') }}</strong> {{ $t('identificacion-de-soluciones-disruptivas-con-un-amplio-margen-de-crecimiento') }}
                                </p>
                            </div>
                            <div class="col-12 col-lg-3 px-3 px-xxl-5" data-aos="fade-right" data-aos-delay="400" data-aos-duration="600">
                                <img :src="`${publicPath}img/01innovacionIcp03.png`" class="img-responsive my-3">
                                <p>
                                <strong class="text-blau2">{{ $t('excelencia-operativa-en-los-procesos-industriales') }}</strong><br>
                                {{ $t('implementacion-de-tecnologias') }}
                                </p>
                            </div>
                            <div class="col-12 col-lg-3 px-3 px-xxl-5" data-aos="fade-right" data-aos-delay="600" data-aos-duration="400">
                                <img :src="`${publicPath}img/01innovacionIcp04.png`" class="img-responsive my-3">
                                <p>
                                <strong class="text-blau2">{{ $t('eficiencia-energetica-y-racionalizacion-del-consumo-de-agua') }}</strong><br>
                                {{ $t('productos-y-servicios-que-contribuyan-a-la-generacion-de-hogares-conectados-y-sostenibles') }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row bg-darkBlue g-0">
                <div class="col-9 m-auto py-5">
                    <h4 class="text-white px-1 mx-0 px-md-5 mx-lg-5" data-aos="fade-left" data-aos-duration="1000">{{ $t('roca-group-ventures-da-prioridad') }}  </h4>
                </div>
            </div>
            <div class="row g-0">
                <div class="col-12 col-lg-9 m-auto pt-0 pt-lg-5 pb-0 pb-lg-5">
                    <h2 class="my-4 mt-5" data-aos="fade" data-aos-duration="1500">{{ $t('innovaciones-de-presente-para-retos-de-futuro') }}</h2>
                    <h4 class="text-turquesa px-1 mx-0 px-md-5 mx-lg-5" data-aos="fade-left" data-aos-duration="1000">{{ $t('roca-group-trabaja-en') }}</h4>
                    <div class="row justify-content-evenly g-0 py-5">
                        <div class="col-11 col-lg-5 pb-5 pb-xl-0 text-center text-lg-start" data-aos="fade-up" data-aos-duration="600">
                            <img :src="`${publicPath}img/01innovacionArquitectura.jpg`" class="img-responsive">
                            <h3 class="text-blau py-0 py-xl-3">{{ $t('arquitectura-modular') }}</h3>
                            <p>{{ $t('el-grupo-trabaja-con') }}</p>

                        </div>
                        <div class="col-11 col-lg-5 text-center text-lg-start" data-aos="fade-up" data-aos-duration="1000">
                            <img :src="`${publicPath}img/01innovacionVortex.jpg`" class="img-responsive">
                            <h3 class="text-blau py-0 py-xl-3">{{ $t('vortex-higiene-y-confort-acustico') }} </h3>
                            <p>{{ $t('nuevo-sistema-de-descarga') }}</p>

                        </div>
                    </div>

                </div>
            </div>

            <div class="row align-items-top g-0">
                <div class="col-12 m-0 p-0" data-aos="fade" data-aos-duration="1000">
                    <img :src="`${publicPath}img/01innovacionFotoXXL.jpg`" class="img-responsive">
                    <div class="row justify-content-center">
                        <div class="col-12 col-lg-10 p-3 px-lg-5">
                            <h2 class="my-4 mt-5" data-aos="fade" data-aos-duration="1500">{{ $t('ona-y-lua-versatilidad-en-cualquier-espacio-de-bano') }}</h2>
                            <h4 class="text-turquesa" data-aos="fade-left" data-aos-duration="1000">{{ $t('ona-de-roca-y-lua-de-laufen') }}</h4>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row g-0">
                <div class="col-12 col-lg-9 m-auto pb-5">
                    <div class="row justify-content-evenly g-0 py-5">
                        <div class="col-11 col-lg-5 pb-5 pb-xl-0 text-center text-lg-start" data-aos="fade-up" data-aos-duration="600">
                            <img :src="`${publicPath}img/01innovacionOna.jpg`" class="img-responsive">
                            <h3 class="text-blau py-0 py-xl-3">{{ $t('ona-simplicidad-natural') }}</h3>
                            <p>{{ $t('el-entorno-natural-y-estilo-de-vida-mediterraneos') }}</p>
                            <p class="text-end"><a :href="ona_url" target="_blank"><span class="btnCollapseIn btnFosc me-0 external-link"><i class="fa-solid fa-link"></i></span></a></p>

                        </div>
                        <div class="col-11 col-lg-5 text-center text-lg-start" data-aos="fade-up" data-aos-duration="1000">
                            <img :src="`${publicPath}img/01innovacionUA.jpg`" class="img-responsive">
                            <h3 class="text-blau py-0 py-xl-3">{{ $t('lua-armonia-y-elegancia-en-cada-detalle') }}</h3>
                            <p>{{ $t('el-disenador-toan-nguyen') }}</p>
                            <p class="text-end"><a href="https://www.laufen-lua.com/" target="_blank"><span class="btnCollapseIn btnFosc me-0 external-link"><i class="fa-solid fa-link"></i></span></a></p>
                        </div>
                    </div>
                    <div class="col-12 m-auto mb-5 fonsGris">
                        <div class="row g-0">
                            <div class="col-12 col-lg-6 p-5 text-center text-xl-start">
                                <h4>{{ $t('slim-nueva-coleccion-de-la-marca-celite-en-brasil') }}</h4>
                                <p>{{ $t('celite-popular-marca-del-grupo-en-brasil') }}</p>
                            </div>
                            <div class="col-12 col-lg-6 text-end p-0 bg-foto" :style="{ backgroundImage: `url(${publicPath}img/01innovacionSlim.jpg)` }"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row bg-darkBlue g-0">
                <div class="col-12 col-lg-9 m-auto py-3 py-lg-5">
                    <div class="row justify-content-between pt-0 pt-lg-5"  data-aos="fade" data-aos-duration="1000">
                        <h2 class="text-turquesa mb-4">{{ $t('la-marca-roca-referencia-de-diseno-mediterraneo') }}</h2>
                        <h4 class="text-white">{{ $t('inovacion-organiz') }}</h4>
                        <div class="col-12 col-lg-6 text-center text-lg-start mt-5">
                            <img :src="`${publicPath}img/01innovacionSpain.jpg`" class="img-responsive mb-2 mb-lg-5">
                            <h4 class="text-turquesa">{{ $t('exposicion-universal-expo-dubai-2020') }}</h4>
                            <p class="text-white px-3 px-lg-0">{{ $t('roca-organizo-el-encuentro-diseno-mediterraneo') }}</p>
                        </div>
                        <div class="col-12 col-lg-6 text-center text-lg-start mt-5">
                            <img :src="`${publicPath}img/01innovacionPabellon.jpg`" class="img-responsive mb-2 mb-lg-5">
                            <h4 class="text-turquesa">{{ $t('presentacion-global-de-ona') }}</h4>
                            <p class="text-white px-3 px-lg-0">{{ $t('primera-presentacion-de-una-coleccion-de-roca') }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row g-0">
                <div class="col-12 col-lg-9 m-auto py-5">
                    <div class="col-12 m-auto mb-0 mb-lg-5 fonsGris">
                        <div class="row g-0">
                            <div class="col-12 col-lg-6 p-5 text-center text-xl-start">
                                <h4>{{ $t('inauguracion-de-laufen-space-milano') }}</h4>
                                <p>{{ $t('laufen-ha-ampliado-su-red-de-showrooms') }}</p>
                                <p class="text-end"><a href="https://www.laufen.com/space/milan" target="_blank"><span class="btnCollapseIn btnFosc me-0 external-link"><i class="fa-solid fa-link"></i></span></a></p>
                            </div>
                            <div class="col-12 col-lg-6 text-end p-0 bg-foto" :style="{ backgroundImage: `url(${publicPath}img/01innovacionLaufen.jpg)` }"></div>
                        </div>
                    </div>
                    <div class="col-12 m-auto mb-0 mb-lg-5 fonsGris">
                        <div class="row g-0">
                            <div class="col-12 col-lg-6 p-5 text-center text-xl-start">
                                <h4>{{ $t('roca-unveils-las-ultimas-innovaciones-explicadas-por-los-especialistas') }}</h4>
                                <p>{{ $t('la-pagina-web-de-roca-ha-estrenado-una-serie-de-videos') }}</p>
                                <p class="text-end"><a href="https://www.roca.com/launches/unveils" target="_blank"><span class="btnCollapseIn btnFosc me-0 external-link"><i class="fa-solid fa-link"></i></span></a></p>
                            </div>
                            <div class="col-12 col-lg-6 text-end p-0 bg-foto" :style="{ backgroundImage: `url(${publicPath}img/01innovacionUnveils.jpg)` }"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row g-0 my-5 align-items-center">
                <div class="col-12 col-lg-6"  data-aos="fade-up" data-aos-duration="600">
                    <img :src="`${publicPath}img/01innovacionPica.jpg`" class="img-responsive">
                </div>
                <div class="col-12 col-lg-6"  data-aos="fade-up" data-aos-duration="1000">
                    <img :src="`${publicPath}img/01innovacionWater.jpg`" class="img-responsive">
                </div>
            </div>
            <div class="row g-0 mt-5 justify-content-center">

                <div class="col-12 col-lg-8">
                    <h2 data-aos="fade" data-aos-duration="1500">{{ $t('premios-internacionales') }}</h2>
                    <h3 class="text-turquesa my-5" data-aos="fade" data-aos-duration="1500">{{ $t('los-productos-y-acciones-de-las-marcas-del-grupo') }}</h3>
                </div>

            </div>

            <div class="row g-0 mb-5 align-items-top">
                <div class="col-12 col-lg-4 pb-5 pb-lg-0"  data-aos="fade-right" data-aos-delay="500" data-aos-duration="1500">
                    <img :src="`${publicPath}img/01innovacionLogo1.gif`" class="img-responsive mb-5">
                    <p>{{ $t('lavabo-horizon-geometric-de-roca') }}<br>{{ $t('disenado-por-joao-armentano') }}</p>
                    <p>{{ $t('lavabo-horizon-skyline-de-roca') }}<br>{{ $t('disenado-por-joao-armentano') }}</p>
                </div>
                <div class="col-12 col-lg-4 pb-5 pb-lg-0"  data-aos="fade-up" data-aos-duration="1500">
                    <img :src="`${publicPath}img/01innovacionLogo2.gif`" class="img-responsive mb-5">
                    <p>{{ $t('lavabo-horizon-skyline-de-roca-0') }}<br>{{ $t('disenado-por-joao-armentano') }}</p>
                    <p>{{ $t('tipografia-corporativa-de-roca') }}<br>{{ $t('disenada-por-pepe-gimeno') }}</p>
                </div>
                <div class="col-12 col-lg-4 pb-5 pb-lg-0"  data-aos="fade-left" data-aos-delay="500" data-aos-duration="1500">
                    <img :src="`${publicPath}img/01innovacionLogo3.gif`" class="img-responsive mb-5">
                    <p>{{ $t('inodoro-save-de-laufen') }}<br>{{ $t('disenado-por-eoos-y-eawag') }}</p>
                </div>
            </div>
        </div>
        <div class="contingut bg-white row g-0 mb-5 pb-5">
            <div class="col-12 mt-5 py-5 mb-5 fonsGris position-relative">
                <h3 class="pb-3 mb-3">{{ $t('contribucion-a-los-ods') }}</h3>
                <div class="row justify-content-center">
                    <div class="col-12 col-lg-4 col-xl-3 col-md-auto mb-4 text-center text-lg-start">
                        <p>{{ $t('impacto-directo') }}</p>
                        <img :src="`${publicPath}img/01avanzando-icono01.gif`" class="img-responsive m-1" width="57">
                        <img :src="`${publicPath}img/01avanzando-icono02.gif`" class="img-responsive m-1" width="57">
                        <img :src="`${publicPath}img/01avanzando-icono04.gif`" class="img-responsive m-1" width="57">
                        <img :src="`${publicPath}img/01avanzando-icono05.gif`" class="img-responsive m-1" width="57">
                    </div>
                    <div class="col-md-auto border-start mb-4 text-center text-lg-start">
                        <p>{{ $t('impacto-indirecto') }}</p>
                        <img :src="`${publicPath}img/01excelencia-icono04.gif`" class="img-responsive m-1">
                        <img :src="`${publicPath}img/01crecimiento-icono06.gif`" class="img-responsive m-1">
                        <img :src="`${publicPath}img/01excelencia-icono07.gif`" class="img-responsive m-1">
                        <img :src="`${publicPath}img/01transformacion-icono08.gif`" class="img-responsive m-1">
                    </div>
                </div>
            </div>

            <hr>
            <div class="row p-0 g-0">
                <div class="col-6 p-3 p-lg-0 m-0 pb-3 text-start">
                    <localized-link class="footerLink" to="/avanzando-hacia-el-futuro/excelencia-operacional"><img :src="`${publicPath}img/breadcrumbBack.gif`" class="img-responsive" width="6"> {{ $t("nav.excelencia-operacional") }}</localized-link>
                </div>
                <div class="col-6 p-3 p-lg-0 m-0 pb-3 text-end">
                    <localized-link class="footerLink" to="/avanzando-hacia-el-futuro/transformacion-digital">{{ $t("nav.transformacion-digital") }} <img :src="`${publicPath}img/breadcrumbGo.gif`" class="img-responsive" width="6"></localized-link>
                </div>
            </div>

        </div>


    </div>
</template>
<script>
    export default {
        name: "InnovacionView",
        data() {
            return {
                publicPath: process.env.BASE_URL,
                ona_url: 'https://www.roca.es/ona-coleccion',
            }
        },
      mounted() {
        if(this.$i18n.locale=="es"){
          this.separator = '.';
        } else {
          this.separator = ',';
          this.ona_url = 'https://www.roca.com/launches/ona';
        }
      }
    }

</script>
